export function ParamsFromURL() {
  const vars = window.location.search.split("&");
  const queryString = {};
  for (let i = 0; i < vars.length; i++) {
    const stringArr = vars[i].split("=");
    const pair = stringArr.map((item) => item.replace("?", ""));
    const key = decodeURIComponent(pair[0]);
    const value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof queryString[key] === "undefined") {
      queryString[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof queryString[key] === "string") {
      const arr = [queryString[key], decodeURIComponent(value)];
      queryString[key] = arr;
      // If third or later entry with this name
    } else {
      queryString[key].push(decodeURIComponent(value));
    }
  }
  return queryString;
}

export function buildInitialValueObjectFromParams(tagPostfix) {
  const params = ParamsFromURL() || {};
  const sortedParams = Object.keys(params).reduce((acc, tag) => {
    if (tag && tag.indexOf(tagPostfix) >= 0) {
      acc[tag] = params[tag];
    }
    return acc;
  }, {});
  return sortedParams;
}

export function functionStringify(obj) {
  return JSON.stringify(obj, function (key, value) {
    var fnBody;
    if (value instanceof Function || typeof value == "function") {
      fnBody = value.toString();

      if (fnBody.length < 8 || fnBody.substring(0, 8) !== "function") {
        //this is ES6 Arrow Function
        return "_NuFrRa_" + fnBody;
      }
      return fnBody;
    }
    if (value instanceof RegExp) {
      return "_PxEgEr_" + value;
    }
    return value;
  });
}

/**
 * Returns the difference in years between two date strings.
 * Returns 0 if one of the date is invalid
 */
export const diffYears = (date1, date2) => {
  try {
    const diffTime = Math.abs(new Date(date2) - new Date(date1));
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffYears = diffDays / 365.25;
    return diffYears;
  } catch (err) {
    return 0;
  }
};

/**
 * Creates a date object from aplyId date
 * which is in format DD/MM/YYYY
 */
export const parseAplyidDate = (dateString = "") => {
  try {
    return new Date(
      dateString.slice(6, 10),
      dateString.slice(3, 5) - 1,
      dateString.slice(0, 2)
    );
  } catch (err) {
    return null;
  }
};
